import { render, staticRenderFns } from "./MassDownloadPolicyScriptModal.vue?vue&type=template&id=54456f52&"
import script from "./MassDownloadPolicyScriptModal.vue?vue&type=script&lang=ts&"
export * from "./MassDownloadPolicyScriptModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports